import React from "react";
import { safeBuilderText } from "~/lib/builder-utils";

export const FeatureSection = ({
  preHeadline,
  headline,
  description,
  look,
  layout,
  children,
  image,
}: {
  preHeadline: unknown;
  headline: unknown;
  description: unknown;
  look: "active" | "inactive";
  layout: "left" | "right";
  children?: React.ReactNode;
  image?: React.ReactNode;
}) => {
  const safePreHeadline = safeBuilderText(preHeadline);
  const safeHeadline = safeBuilderText(headline);
  const safeDescription = safeBuilderText(description);

  return (
    <div className="mt-8 flex flex-col items-stretch gap-8 md:mt-16 md:gap-16">
      <div className="mx-auto grid max-w-screen-lg gap-4 md:grid-cols-2 md:gap-12">
        <div className={"left" === layout ? "" : "md:col-start-2"}>
          <p
            className={`mb-4 text-sm font-medium uppercase tracking-wide ${
              "active" === look ? "text-violet-500" : "text-gray-500"
            }`}
          >
            {safePreHeadline}
          </p>
          <h3 className="mx-auto mb-4 text-2xl font-medium tracking-tight">
            {safeHeadline}
          </h3>
          <p className="text-md mb-4 leading-loose text-gray-800">
            {safeDescription}
          </p>
          {children}
        </div>
        <div
          className={`${
            "left" === layout ? "" : "md:col-start-1 md:row-start-1"
          } rounded-xl bg-gray-900 p-2 shadow-lg`}
        >
          {image}
        </div>
      </div>
    </div>
  );
};
